module.exports = __webpack_public_path__ + "img/galet_porto.7bd4b87b.jpg";